import { DISPATCHER } from 'src/features/yellStory/constants/actionType'
import {
  dominantArmObjs,
  sizeObjs,
  fingerGuardTypeObjs,
  leatherIntegratedIndexObjs,
  leatherIntegratedMiddleObjs,
  leatherIntegratedRingObjs,
  materialPackObjs,
  webPartsObjs,
  seriesAllObjs
} from 'src/features/yellStory/constants/bases'
import { ysrLabelObjs, hamidashiObjs, stitchObjs, laceObjs, edgeColors } from 'src/features/yellStory/constants/colors'
import { PartialActionDispatch, ResponseDispatch } from 'src/types'
import { objectsFilter } from 'src/logic'
import { colorObjs, directLogo1Objects, directLogo2Objects, originalEmbroideryObjects } from '../constants/embroidery'

// ここはブランドのドメイン
const dispatchBaseStore = {
  // base
  series: { objects: seriesAllObjs, actionType: DISPATCHER['series'] },
  dominantArm: { objects: dominantArmObjs, actionType: DISPATCHER['dominantArm'] },
  size: { objects: sizeObjs, actionType: DISPATCHER['size'] },
  fingerGuardType: { objects: fingerGuardTypeObjs, actionType: DISPATCHER['fingerGuardType'] },
  leatherIntegratedIndex: { objects: leatherIntegratedIndexObjs, actionType: DISPATCHER['leatherIntegratedIndex'] },
  leatherIntegratedMiddle: { objects: leatherIntegratedMiddleObjs, actionType: DISPATCHER['leatherIntegratedMiddle'] },
  leatherIntegratedRing: { objects: leatherIntegratedRingObjs, actionType: DISPATCHER['leatherIntegratedRing'] },
  materialPack: { objects: materialPackObjs, actionType: DISPATCHER['materialPack'] },
  webParts: { objects: webPartsObjs, actionType: DISPATCHER['webParts'] },
  // color
  lace: { objects: laceObjs, actionType: DISPATCHER['lace'] },
  edge: { objects: edgeColors, actionType: DISPATCHER['edge'] },
  stitch: { objects: stitchObjs, actionType: DISPATCHER['stitch'] },
  hamidashi: { objects: hamidashiObjs, actionType: DISPATCHER['hamidashi'] },
  ysrLabel: { objects: ysrLabelObjs, actionType: DISPATCHER['ysrLabel'] },
  ysrOriginalEmbroidery: { objects: originalEmbroideryObjects, actionType: DISPATCHER['ysrOriginalEmbroidery'] },
  ysrDirectLogo1Position: { objects: directLogo1Objects, actionType: DISPATCHER['ysrDirectLogo1Position'] },
  ysrDirectLogo1MainColor: { objects: colorObjs, actionType: DISPATCHER['ysrDirectLogo1MainColor'] },
  ysrDirectLogo1EdgeColor: { objects: colorObjs, actionType: DISPATCHER['ysrDirectLogo1EdgeColor'] },
  ysrDirectLogo2Position: { objects: directLogo2Objects, actionType: DISPATCHER['ysrDirectLogo2Position'] },
  ysrDirectLogo2Color: { objects: colorObjs, actionType: DISPATCHER['ysrDirectLogo2Color'] }
}

export const useDispatcher = (key: string, dispatch: PartialActionDispatch): ResponseDispatch => {
  const item = dispatchBaseStore[key]
  return (selected: string) =>
    dispatch({
      type: item.actionType,
      [key]: objectsFilter(selected, item.objects)
    })
}
